__turbopack_context__.v({
  "celebration": "styles-module-scss-module__Y1bY-G__celebration",
  "contentBtn": "styles-module-scss-module__Y1bY-G__contentBtn",
  "contentHeadline": "styles-module-scss-module__Y1bY-G__contentHeadline",
  "contentWrapper": "styles-module-scss-module__Y1bY-G__contentWrapper",
  "errorText": "styles-module-scss-module__Y1bY-G__errorText",
  "errorText__black": "styles-module-scss-module__Y1bY-G__errorText__black",
  "errorText__pink2": "styles-module-scss-module__Y1bY-G__errorText__pink2",
  "fade": "styles-module-scss-module__Y1bY-G__fade",
  "nextSpinText": "styles-module-scss-module__Y1bY-G__nextSpinText",
  "rewardSection": "styles-module-scss-module__Y1bY-G__rewardSection",
  "rewardSectionSubtitle": "styles-module-scss-module__Y1bY-G__rewardSectionSubtitle",
  "rewardSectionSubtitlePulsz": "styles-module-scss-module__Y1bY-G__rewardSectionSubtitlePulsz",
  "rewardSectionTitle": "styles-module-scss-module__Y1bY-G__rewardSectionTitle",
  "rewardSectionTitlePulsz": "styles-module-scss-module__Y1bY-G__rewardSectionTitlePulsz",
  "rewardSectionTitleSmall": "styles-module-scss-module__Y1bY-G__rewardSectionTitleSmall",
  "wheel": "styles-module-scss-module__Y1bY-G__wheel",
  "wheelErorTextWrapper": "styles-module-scss-module__Y1bY-G__wheelErorTextWrapper",
  "wheelWrapper": "styles-module-scss-module__Y1bY-G__wheelWrapper",
});
